﻿export default class CookieWarningBarHandler {
    constructor() {

        // els
        this.cookieLevelButton = '[data-lf-cookie-level]';
        this.cookieBarContainer = '[data-lf-cookie-bar]';
        this.changeCookiesChoices = '[data-lf-change-cookie-choices]';

        // cookie
        this.cookieLevel = 'cookieLevel';
        this.cookieMaxAge = null;

        const secondsPerDay = 60 * 60 * 24;
        this.week = secondsPerDay * 7;
        this.year = secondsPerDay * 365;

        // classes 
        this.hiddenClass = 'js-hidden';

        this.initialize();

        if (!this.__cookiesSelected()) {
            this.__showCookieBar();
        } else {
            this.__hideCookieBar();
        }

        this.__setupChangeCookiesListener(this.changeCookiesChoices);
    }

    initialize = () => {
        const buttons = document.querySelectorAll(this.cookieLevelButton);
        this.__setupButtonListener(buttons);
    }

    __setupChangeCookiesListener(button) {
        const changeButton = document.querySelector(button);

        if (changeButton) {
            changeButton.addEventListener('click', event => {
                this.__showCookieBar();
            })
        } 
    }

    __setupButtonListener(buttons) {
        buttons.forEach((button) => {
            button.addEventListener('click', event => {
                const val = parseInt(button.dataset.value);
                this.__setCookieLevel(val);
            });
        })
    }
   
    __setCookieLevel(val) {
        if (val === 1) {
            this.cookieMaxAge = this.week;
        } else  {
            this.cookieMaxAge = this.year;

            if(typeof dataLayer !== "undefined") {
                dataLayer.push({ 'event': 'allowcookies' });
            }
        }
        document.cookie = `${this.cookieLevel}=${val};path=/;max-age=${this.cookieMaxAge}`;
        this.__hideCookieBar();
    }

    __showCookieBar() {
        const cookieBar = document.querySelector(this.cookieBarContainer);
        cookieBar.classList.remove(this.hiddenClass);
    }

    __hideCookieBar() {
        const cookieBar = document.querySelector(this.cookieBarContainer);
        cookieBar.classList.add(this.hiddenClass);
    }

    __cookiesSelected() {
        return document.cookie.split(';')
            .filter((item) => item.includes(`${this.cookieLevel}=`))
            .length;
    }
}